export const UK_DRIVING_LICENCE_REGEX = /^[A-Z9]{5}\d{6}[A-Z9]{2}\d[A-Z]{2}$/;

export const UK_PHONE_REGEX = /^(?:44|0)7\d{9}$/;
export const EXTENDED_UK_PHONE_REGEX = /^(?:\+?44|0)(?:7\d{9}|[12]\d{9})$/;
export const UK_US_PHONE_REGEX = /^(?:\+?44|0(?:7|[12])\d{9}|\+?1\d{10})$/;
export const UK_EU_US_PHONE_REGEX =
  /^(\+?(44|1|3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9])|0)?\d{6,14}$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
